$(function () {
  $(document).bind('ajaxStop', function (event) {
    var formWrapper = $('body > footer > .footer-contact-wrapper .footer-contact-form');
    var gdprLink = formWrapper.data('gdpr-link');

    formWrapper.find('.gdpr-appendix > a').attr('href', gdprLink);
  });
});